import { Component } from "react"
import ReactGA from 'react-ga'


class GoogleAnalytics extends Component {
  setGA = () => {
    ReactGA.initialize('G-QB3YTBFZCP')
    ReactGA.pageview('Init page view')
  }

  componentDidMount() {
    this.setGA()
  }

  render() {
    return (
      <div>
        
      </div>
    )
  }
}

export default GoogleAnalytics